import clsx from 'clsx';
import { initials } from '@/lib/format';

interface Props {
  name?: string | null;
  src?: string | null;
  size?: number;
  className?: string;
  'aria-label'?: string;
}

function colorFor(name: string): string {
  // Stable color from name
  const palette = [
    'bg-brand-500',
    'bg-blue-500',
    'bg-amber-500',
    'bg-rose-500',
    'bg-emerald-500',
    'bg-violet-500',
    'bg-fuchsia-500',
    'bg-sky-500',
    'bg-orange-500',
    'bg-teal-500',
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return palette[hash % palette.length];
}

export default function UserAvatar({ name, src, size = 40, className, ...rest }: Props) {
  const fallbackName = name ?? '?';
  const i = initials(fallbackName);
  const dim = `${size}px`;
  return (
    <span
      role="img"
      aria-label={rest['aria-label'] ?? fallbackName}
      className={clsx(
        'inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full font-semibold text-white',
        src ? 'bg-ink-200 dark:bg-ink-700' : colorFor(fallbackName),
        className,
      )}
      style={{ width: dim, height: dim, fontSize: Math.max(11, Math.floor(size / 2.6)) }}
    >
      {src ? (
        <img
          src={src}
          alt=""
          className="h-full w-full object-cover"
          loading="lazy"
          referrerPolicy="no-referrer"
        />
      ) : (
        <span aria-hidden="true">{i}</span>
      )}
    </span>
  );
}
